module.exports = __webpack_public_path__ + "img/hakhak_letter.cf5c33b7.jpg";